import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import NextApp from './NextApp';
import { history } from './redux/store';
// import registerServiceWorker from './registerServiceWorker';

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root'),
  );
};

// Initialize sentry
const envVar = `REACT_APP_SENTRY_DNS_${process.env.REACT_APP_ENVIRONMENT.toString().toUpperCase()}`;
Sentry.init({
  dsn: process.env[envVar],
  integrations: [new Integrations.BrowserTracing({
    routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
  })],
  tracesSampleRate: 1.0,
  normalizeDepth: 10,
});

// Do this once
// registerServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
